import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { FormikTextField } from '@/common/presentation/components/forms/fields/FormikTextField';
import { FormikDatePicker } from '@/common/presentation/components/forms/fields/FormikDatePicker';
import { RaptorJobFormValues } from '../../../RaptorJobValidationSchema';
import { addDays, differenceInDays } from 'date-fns';
import tid from '@/common/application/utils/tid';

export const MultiDayJobRecurrence = () => {
  const { values, setFieldValue } = useFormikContext<RaptorJobFormValues>();

  if (values.recurrence !== 'multi') {
    return <Box sx={{ flex: 1, display: { xs: 'none', sm: 'inline' } }} />;
  }

  return (
    <>
      <FormikTextField<RaptorJobFormValues>
        id="estimatedDurationDays"
        label="Est. Duration Days"
        type="number"
        sx={{ flex: 1 }}
        onChange={(event) => {
          setFieldValue('estimatedDurationDays', Number(event.target.value));
          if (values.startDate) {
            setFieldValue('endDate', addDays(values.startDate, Number(event.target.value)));
          }
        }}
        {...tid('jobs:create:duration-days-input')}
      />
      <FormikDatePicker<RaptorJobFormValues>
        id="endDate"
        label="End Date"
        sx={{ flex: 1 }}
        onChange={(inputValue) => {
          setFieldValue('endDate', inputValue);
          if (inputValue && values.startDate) {
            setFieldValue('estimatedDurationDays', differenceInDays(inputValue, values.startDate));
          }
        }}
        {...tid('jobs:create:end-date-input')}
      />
    </>
  );
};
